import { render, staticRenderFns } from "./VirtualTour.vue?vue&type=template&id=2617488b&"
import script from "./VirtualTour.vue?vue&type=script&lang=js&"
export * from "./VirtualTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports